var _defs, _circle, _g, _rect, _g2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.89 113.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c1f81;}.cls-2{fill:#ff8f0b;}.cls-3{fill:#eaeced;}.cls-4,.cls-5,.cls-6{fill:none;}.cls-5,.cls-6{stroke:#fff;stroke-linecap:round;}.cls-5{stroke-miterlimit:10;stroke-width:4px;}.cls-6{stroke-miterlimit:10;stroke-width:5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    className: "cls-1",
    cx: 56.94,
    cy: 56.94,
    r: 56.94
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_153",
    "data-name": "Path 153"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.53,109.37A51.59,51.59,0,0,1,4.88,57.71,51.63,51.63,0,0,1,93.06,21.19a51.68,51.68,0,0,1-16.42,84.12A51.22,51.22,0,0,1,56.53,109.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.53,8.06A49.65,49.65,0,0,0,21.42,92.83,49.67,49.67,0,1,0,56.53,8.06m0-4A53.66,53.66,0,1,1,2.88,57.71,53.65,53.65,0,0,1,56.53,4.06Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    className: "cls-4",
    x: 32.02,
    y: 30.13,
    width: 48.82,
    height: 54.9
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    className: "cls-1",
    d: "M44.89,55.28a14.3,14.3,0,1,1,28.6,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    className: "cls-5",
    d: "M78.79,74.86a26,26,0,1,1,.85-33.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    className: "cls-6",
    d: "M73.28,67.56a22.63,22.63,0,0,0-14.65-5.32c-5.49-.1-9.4,1.79-13.67,5.22"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    className: "cls-4",
    x: 32.02,
    y: 30.13,
    width: 48.82,
    height: 54.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/Icon6.bc82d272dd078468eab8311704c9f35d.svg";
export { ForwardRef as ReactComponent };